// @owners { team: patients-team }

export const FETCH_APPLE_PAY_SUPPORT_SUCCEEDED = 'FETCH_APPLE_PAY_SUPPORT_SUCCEEDED';

export type ActionFetchApplePaySupportSucceeded = {
  type: typeof FETCH_APPLE_PAY_SUPPORT_SUCCEEDED;
  payload: boolean;
};
export function fetchApplePaySupportSucceeded(isApplePaySupported: boolean): ActionFetchApplePaySupportSucceeded {
  return {
    type: FETCH_APPLE_PAY_SUPPORT_SUCCEEDED,
    payload: isApplePaySupported,
  };
}

export type ApplePayActions = ActionFetchApplePaySupportSucceeded;
